import { CustomizationSettings } from "../../../commons/types/settings";

export default (customization?: CustomizationSettings) =>
  customization?.bikeCenterName ? customization.bikeCenterName : "BikeCenter";
